import React from "react";

interface LinksContainerProps {
  children: React.ReactNode;
}

export function LinksContainer({ children }: LinksContainerProps) {
  return <div className="list-links-template__links-container">{children}</div>;
}
